/** Fallback IB/parent account used when the signup link carries no `ptr` param. */
export const DEFAULT_PARENT_ID = "2000219863";
/** CRM user id used as Account Owner when the signup link carries no `rm` param. */
export const DEFAULT_AGENT_ID = "774";
/** Entity used for Nafdak/Nafdaq signups. */
export const DEFAULT_ENTITY = "GODOFS";

export function resolveSignupParentId(ptr, formParentId) {
  return ptr || formParentId || DEFAULT_PARENT_ID;
}

export function resolveSignupAgentId(rm) {
  return rm || DEFAULT_AGENT_ID;
}

export function resolveSignupEntity(entity) {
  const host = String(
    typeof window !== "undefined" ? window.location.hostname : ""
  ).toLowerCase();
  if (host.includes("nafdak") || host.includes("nafdaq")) {
    return DEFAULT_ENTITY;
  }
  return entity || DEFAULT_ENTITY;
}
